{
  "actionbar.actions": "액션",
  "actionbar.actionsAvailable": "사용 가능한 액션",
  "actionbar.clearSelection": "선택 항목 지우기",
  "actionbar.selected": "{count, plural, =0 {선택된 항목 없음} other {#개 선택됨}}",
  "actionbar.selectedAll": "모두 선택됨",
  "breadcrumbs.more": "기타 항목",
  "button.pending": "보류 중",
  "calendar.invalidSelection": "선택한 {selectedCount, plural, one {일자를} other {일자를}} 사용할 수 없습니다.",
  "combobox.noResults": "결과 없음",
  "contextualhelp.help": "도움말",
  "contextualhelp.info": "정보",
  "datepicker.endTime": "종료 시간",
  "datepicker.startTime": "시작 시간",
  "datepicker.time": "시간",
  "dialog.alert": "경고",
  "dialog.dismiss": "무시",
  "dropzone.replaceMessage": "파일을 드롭하여 바꾸기",
  "inlinealert.informative": "정보",
  "inlinealert.negative": "오류",
  "inlinealert.notice": "경고",
  "inlinealert.positive": "성공",
  "label.(optional)": "(선택 사항)",
  "label.(required)": "(필수 사항)",
  "menu.moreActions": "기타 액션",
  "notificationbadge.indicatorOnly": "새로운 활동",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "선택…",
  "slider.maximum": "최대",
  "slider.minimum": "최소",
  "table.loading": "로드 중…",
  "table.loadingMore": "추가 로드 중…",
  "table.resizeColumn": "열 크기 조정",
  "table.sortAscending": "오름차순 정렬",
  "table.sortDescending": "내림차순 정렬",
  "tag.actions": "액션",
  "tag.hideButtonLabel": "간략히 보기",
  "tag.noTags": "없음",
  "tag.showAllButtonLabel": "모두 표시 ({tagCount, number})",
  "toast.clearAll": "모두 지우기",
  "toast.collapse": "접기",
  "toast.showAll": "모두 표시"
}
